<template>
  <b-card>
    <b-row>
      <!-- User Info: Left col -->
      <b-col cols="21" xl="6" class="d-flex justify-content-between flex-column">
        <!-- User Avatar & Action Buttons -->
        <div class="d-flex justify-content-start">
          <b-avatar
            :src="userData.avatar"
            :text="avatarText(userData.fullName)"
            :variant="`light-${resolveUserRoleVariant(userData.role)}`"
            size="104px"
            rounded
          />
          <div class="ml-1">
            <div>
              <h4 class="mb-0" style="text-transform: capitalize;">
                {{ userData.fullName }}
              </h4>
              <p style="margin: 0; margin-top: 5px;">
                <feather-icon icon="MailIcon" class="mr-75" />
                {{ userData.email }}
              </p>
              <p style="margin: 0; margin-top: 5px;">
                <feather-icon icon="PhoneIcon" class="mr-75" />
                {{ userData.mobile }}
              </p>
              <p v-if="user.role === 'admin'" style="margin: 0; margin-top: 5px;">
                <feather-icon icon="HashIcon" class="mr-75" />
                {{ userData.uid }}
              </p>
            </div>
          </div>
        </div>
      </b-col>

      <!-- Right Col: Table -->
      <b-col cols="12" xl="6">
        <table class="mt-2 mt-xl-0 w-100">
          <tr>
            <th class="pb-50">
              <span class="font-weight-bold">{{$t('profession')}}</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{ userData.role }}
            </td>
          </tr>
          <tr v-if="appConfig.type === 'hw-admin'">
            <th class="pb-50">
              <span class="font-weight-bold">LOVE</span>
            </th>
            <div style="display: flex; flex-direction: row;">
              <td>
                {{ userData.love ? `Kyllä${userData.loveGranted ? `, myönnetty ${`${new Date(userData.loveGranted.toDate()).getDate()}.${new Date(userData.loveGranted.toDate()).getMonth() + 1}.${new Date(userData.loveGranted.toDate()).getFullYear()}`}` : ''}` : 'Ei' }}
              </td>
            </div>
          </tr>
          <tr>
            <th class="pb-50">
              <span class="font-weight-bold">{{$t('car_available')}}</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{ userData.carAvailable ? 'Kyllä' : 'Ei' }}
            </td>
          </tr>
          <tr>
            <th>
              <span class="font-weight-bold">{{$t('driving_license')}}</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{ userData.drivingLicense ? userData.drivingLicense.join(', ') : '' }}
            </td>
          </tr>
          <tr v-if="appConfig.type === 'hw-admin'">
            <th>
              <td class="pb-50 text-capitalize">
                {{ `Tuberkuloosikyselyyn ${userData.tuberculosisSurvey ? `vastattu ${new Date(userData.tuberculosisSurvey.completed.toDate()).getDate()}.${new Date(userData.tuberculosisSurvey.completed.toDate()).getMonth() + 1}.${new Date(userData.tuberculosisSurvey.completed.toDate()).getFullYear()}, ${userData.tuberculosisSurvey.risk ? 'kohonnut riski' : 'ei riskiä'}` : 'ei vastattu'}` }}
              </td>
            </th>
          </tr>
        </table>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { BCard, BAvatar, BRow, BCol } from 'bootstrap-vue'
import { avatarText } from '@hw-ui/utils/filter'
import useUsersList from '../personel-list/usePersonelList'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BAvatar,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    user() {
      return this.$store.state.appAuth.authUser || {}
    },
    appConfig() {
      return this.$store.state.app.appConfig || {}
    }
  },
  setup() {
    const { resolveUserRoleVariant } = useUsersList()
    return {
      avatarText,
      resolveUserRoleVariant,
    }
  },
}
</script>

<style></style>
